// Formatea una fecha aplicando el timezone del usuario.
// dateStr: string ISO o Date.
// timezone: IANA string (ej "America/Argentina/Buenos_Aires").
// idiId: 1=español, 2=inglés.
// showTime: incluir hora y minutos.
export function formatDate(dateStr, timezone, idiId, { showTime = false } = {}) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return String(dateStr);
  const locale = idiId === 2 ? 'en-US' : 'es-AR';
  const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const opts = { day: '2-digit', month: '2-digit', year: '2-digit', timeZone: tz };
  if (showTime) { opts.hour = '2-digit'; opts.minute = '2-digit'; }
  return new Intl.DateTimeFormat(locale, opts).format(d);
}
